import axios from 'axios'
import * as Sentry from '@sentry/vue'

const APP_ID = 'c22bcf5b-b26d-4d86-8d1c-4984f51fc81b'
let scriptLoaded = false

function loadScript() {
  if (scriptLoaded) return
  scriptLoaded = true
  ;(function () {
    const e = window
    const t = document
    const n = function () {
      n.e(arguments)
    }
    n.q = []
    n.e = function (args) {
      n.q.push(args)
    }
    e.Pylon = n
    const r = function () {
      const s = t.createElement('script')
      s.setAttribute('type', 'text/javascript')
      s.setAttribute('async', 'true')
      s.setAttribute('src', `https://widget.usepylon.com/widget/${APP_ID}`)
      const first = t.getElementsByTagName('script')[0]
      first.parentNode.insertBefore(s, first)
    }
    if (t.readyState === 'complete') {
      r()
    } else if (e.addEventListener) {
      e.addEventListener('load', r, false)
    }
  })()
}

export async function bootPylonWidget(user) {
  let identity
  try {
    const res = await axios.get('/api/integrations/pylon/identity-hash/')
    const isJson = (res.headers?.['content-type'] || '').includes(
      'application/json',
    )
    identity = isJson ? res.data : undefined
  } catch (err) {
    Sentry.captureException(err, { tags: { context: 'pylon_identity_hash' } })
    window.pylon = { chat_settings: { app_id: APP_ID } }
    loadScript()
    return
  }

  if (!identity?.email || !identity?.email_hash) {
    Sentry.captureMessage('Pylon identity-hash returned no email/email_hash', {
      level: 'warning',
      tags: { context: 'pylon_identity_hash' },
    })
    window.pylon = { chat_settings: { app_id: APP_ID } }
    loadScript()
    return
  }

  const nameParts = [user.first_name, user.last_name].filter(Boolean)
  window.pylon = {
    chat_settings: {
      app_id: APP_ID,
      email: identity.email,
      name: nameParts.length ? nameParts.join(' ') : identity.email,
      email_hash: identity.email_hash,
    },
  }
  loadScript()
}

export function shutdownPylonWidget() {
  if (typeof window.Pylon === 'function') window.Pylon('hideChatBubble')
}

export function hidePylonWidget() {
  if (typeof window.Pylon === 'function') window.Pylon('hideChatBubble')
}

export function showPylonWidget() {
  if (typeof window.Pylon === 'function') window.Pylon('showChatBubble')
}
